<div class="view-users-modal">
  <div class="modal-header mb-4">

    @if(totalReviewersCountMessage){
      <div class="mb-3">
        <p [innerHTML]="totalReviewersCountMessage"></p>
      </div>
    }
   
    @if (showDeleteConfirmation && showDeleteOption && deleteMessage) {
      <div>
        <p [innerHTML]="deleteMessage"></p>
      </div>
    }
  </div>

  @if (showUsersOnly) {
        <p-table
            styleClass="p-datatable-sm p-datatable-sm--normal"
            [value]="users"
            [paginator]="true"
            [rows]="10"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} - {last} of {totalRecords}"
            autoLayout="true"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Name</th>
              <th>Email</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-user>
            <tr class="cursor-pointer" (click)="openReviewerDialog(user._id)">
              <td>{{ user.firstName }} {{ user.lastName }}</td>
              <td>{{ user.email }}</td>
            </tr>
          </ng-template>
        </p-table>
  }

  <div class="modal-footer mt-4 flex justify-content-end gap-2">
    @if (showDeleteConfirmation && showDeleteOption) {
      <p-button
        label="cancel"
        [outlined]="true"
        (onClick)="closeDialog()"
        [rounded]="true"
      />
      <p-button
        label="view users"
        severity="info"
        (onClick)="viewUsersOnly()"
        [rounded]="true"
        styleClass="freshgreen-background"
      />
     <p-button
        [rounded]="true"
        (click)="confirmDelete()"
        [label]="actionLabel"
        severity="danger"
      />
    } @else {
      <p-button
        label="close"
        [outlined]="true"
        (onClick)="closeDialog()"
        [rounded]="true"
      />
     <p-button
        [label]="actionLabel"
        [rounded]="true"
        (click)="confirmDelete()"
        severity="danger"
    />
    }
  </div>
</div>